/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toUserProps, toUserRequest } from './translator/user'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchUser, GetUser, DeleteUser, PutUser } from '@/infrastructure/network/Monitaro/requests/user'
import { IUserProps } from '@/entities/User'

export default class User extends MonitaroGatewayBase {
  async FetchUser(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchUser(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.users.map((prop) => toUserProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetUser(id: string) {
    const { user } = await this.apiClient.request(new GetUser(id))
    return toUserProps(user)
  }

  async DeleteUser(id: string) {
    const { user } = await this.apiClient.request(new DeleteUser(id))
    return toUserProps(user)
  }

  async PutUser(id: string, params: IUserProps) {
    const { user } = await this.apiClient.request(new PutUser(id, toUserRequest(params)))
    return toUserProps(user)
  }
}
